import styled from "@emotion/styled";
// eslint-disable-next-line no-restricted-imports
import { Separator as RadixSeparator, type SeparatorProps as RadixSeparatorProps } from "@radix-ui/themes";
import type React from "react";

import type { ColorTypes } from "@themes/colors";
import { theme } from "@themes/themes";

interface SeparatorProps {
  color?: ColorTypes;
}

export const Separator: React.FC<SeparatorProps & Omit<RadixSeparatorProps, "color">> = ({ color, ...props }) => {
  return <StyledSeparator customcolor={color} {...props} color={undefined} />;
};

const StyledSeparator = styled(RadixSeparator)<{ customcolor?: ColorTypes }>`
  background-color: ${({ customcolor }) => (customcolor ? theme.color(customcolor) : theme.color("gray-5"))} !important;
`;
